import React from "react";
import { baseUrl } from "../../api/Client";
import Card from "../../components/Card";

export default function UserCard({ user, onEdit, onDelete }) {
  return (
    <Card
      avatar={`${baseUrl}/img/avatar/${user.id}/100/100`}
      title={user.name}
      status={{
        label: user.enabled ? "Ativo" : "Inativo",
        color: user.enabled ? "green-400" : "disabled",
      }}
      onEdit={onEdit}
      onDelete={onDelete}
    >
      <p>{`ID: ${user.id}`}</p>
      <p>{user.email}</p>
      <p>{user.phone}</p>
    </Card>
  );
}
